// src/pages/Aliarse.js
// Landing pública para el flujo "Aliarse a la red".

import React, { useState } from 'react';
import {
  Box, Container, Typography, Button, Grid, Paper, Chip,
} from '@mui/material';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import AliarseModal from '../components/AliarseModal';

const BENEFICIOS = [
  { icon: <StorefrontOutlinedIcon />,     title: 'Venta en el marketplace',
    desc: 'Tu negocio disponible online para clientes en toda la red.' },
  { icon: <LocalOfferOutlinedIcon />,     title: 'Aceptación de códigos de canje',
    desc: 'Personas sin recursos para afiliarse compran en tu tienda para ingresar a la red.' },
  { icon: <TrendingUpOutlinedIcon />,     title: 'Aumento de ventas',
    desc: 'Mayor exposición dentro de una red creciente de asociados.' },
  { icon: <HandshakeOutlinedIcon />,      title: 'Puerta a beneficios plenos',
    desc: 'El dueño puede luego afiliarse como asociado y recibir todos los beneficios de la cooperativa.' },
];

const PASOS = [
  'Acuerda con el gestor comercial de la federación el porcentaje de descuento aplicable.',
  'Completa el formulario con los datos legales del negocio, ubicación y descuento.',
  'Envía tu solicitud — quedará pendiente de aprobación por un auditor.',
  'Recibes contacto por email para subir documentos (RUT, cámara de comercio) y realizar el pago.',
  'Una vez aprobado, tu negocio se visibiliza en el marketplace de la red.',
];

export default function Aliarse() {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ minHeight:'100vh', pb: 6 }}>
      {/* Hero */}
      <Box sx={{
        background:'linear-gradient(135deg,#1a4d2e,#2e7d32)',
        color:'#fff', py: 8, mb: 6,
      }}>
        <Container maxWidth="lg">
          <Chip label="ALIADO COMERCIAL" sx={{ bgcolor:'rgba(255,255,255,0.15)', color:'#fff', mb: 2 }} />
          <Typography variant="h3" sx={{ fontWeight: 800, mb: 2 }}>
            Aliarse a la Red
          </Typography>
          <Typography sx={{ fontSize:'1.15rem', maxWidth: 780, mb: 4, color:'rgba(255,255,255,0.9)' }}>
            Si tienes un establecimiento comercial — tienda, panadería, ferretería, droguería,
            fruver, restaurante o similar — puedes integrarte a la red bajo FENAGRO APL, vender
            en nuestro marketplace y aceptar los códigos de canje que emitimos a futuros asociados.
          </Typography>
          <Button variant="contained" size="large"
            onClick={() => setOpen(true)}
            sx={{ bgcolor:'#2e7d32', color:'#fff', fontWeight:700, px: 4,
                  '&:hover': { bgcolor:'#1b5e20' } }}>
            Iniciar mi vinculación como aliado
          </Button>
        </Container>
      </Box>

      <Container maxWidth="lg">
        {/* Beneficios */}
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 3, color:'#1a4d2e' }}>
          Beneficios de aliarse
        </Typography>
        <Grid container spacing={2} sx={{ mb: 6 }}>
          {BENEFICIOS.map((b, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Paper elevation={0} sx={{
                p: 3, height: '100%', borderRadius: 3, border: '1px solid #e0e0e0',
              }}>
                <Box sx={{ color:'#2e7d32', mb: 1.5, '& svg': { fontSize: 40 } }}>{b.icon}</Box>
                <Typography sx={{ fontWeight: 700, mb: 0.5 }}>{b.title}</Typography>
                <Typography variant="body2" sx={{ color:'#666' }}>{b.desc}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Cómo funciona */}
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 3, color:'#1a4d2e' }}>
          Cómo funciona
        </Typography>
        <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border:'1px solid #e0e0e0', mb: 6 }}>
          <Box component="ol" sx={{ pl: 0, m: 0, listStyle:'none' }}>
            {PASOS.map((p, i) => (
              <Box component="li" key={i} sx={{ display:'flex', gap: 2, mb: 2, alignItems:'flex-start' }}>
                <Box sx={{
                  bgcolor:'#2e7d32', color:'#fff', width: 30, height: 30, borderRadius: '50%',
                  display:'flex', alignItems:'center', justifyContent:'center', fontWeight: 700,
                  flexShrink: 0,
                }}>{i + 1}</Box>
                <Typography sx={{ pt: 0.3 }}>{p}</Typography>
              </Box>
            ))}
          </Box>
        </Paper>

        {/* CTA final */}
        <Box sx={{ textAlign:'center', py: 4, bgcolor:'#f5f7f5', borderRadius: 3 }}>
          <CheckCircleOutlineIcon sx={{ fontSize: 56, color:'#2e7d32', mb: 1 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, color:'#1a4d2e' }}>
            ¿Listo para comenzar?
          </Typography>
          <Typography sx={{ color:'#555', mb: 3, maxWidth: 600, mx:'auto' }}>
            El proceso toma unos 5 minutos. Al enviar, tu solicitud queda pendiente y te contactamos
            por email para los siguientes pasos.
          </Typography>
          <Button variant="contained" size="large"
            onClick={() => setOpen(true)}
            sx={{ bgcolor:'#2e7d32', px: 4, '&:hover':{ bgcolor:'#1a4d2e' } }}>
            Iniciar solicitud
          </Button>
        </Box>
      </Container>

      <AliarseModal open={open} onClose={() => setOpen(false)} />
    </Box>
  );
}
